<template>
  <div class="w">
    <div class="datails_nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Assume' }">揭榜挂帅</el-breadcrumb-item>
        <el-breadcrumb-item>"揭榜挂帅"张榜项目详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="toptitle">
      <div class="titletext">{{ Zblist.Title }}</div>
      <div class="hr">
        <div class="titlespan">
          <p>所属领域：{{Zblist.TechFieldEnumCn}}</p>
          <p>技术来源：{{Zblist.Source}}</p>
          <p>单位名称：{{ Zblist.CompanyOrPersonName }}</p>
          <div class="person">
            <p>联系人：{{ Zblist.ContactsName }}</p>
            <p>手机：{{ Zblist.ContactsTel }}</p>
            <p>电子邮箱：{{ Zblist.ContactsEmail }}</p>
            <p>
              归口专业处：
              <span v-if="Zblist.IsTechnical === 0">高新技术处</span>
              <span v-else>科技成果转化处</span>
            </p>
          </div>
        </div>
        <div>
          <button class="btnShou bnt-one" @click="Zbguashui(Zblist.ID)">
            <div v-if="Zblist.iscollection==0">
              <img src="../../assets/Assume-Image/xin.png" alt />
              <span>收藏</span>
            </div>
            <div v-else>
              <img src="../../assets/Assume-Image/fillSc.png" alt />
              <span>已收藏</span>
            </div>
          </button>
          <button class="jiedui" @click="docking">
            <img src="../../assets/Assume-Image/xing.png" alt />
            <span>我要对接</span>
          </button>
        </div>
      </div>
    </div>
    <div class="datg">
      <span v-if="Zblist.IsTechnical === 0">技术需求内容描述：</span>
      <span v-else>拟转化成果简介:</span>
      <div v-if="Zblist.IsTechnical === 0">
        <div class="tonging" v-html="Zblist.DemandDescription"></div>
        <div class="quing">对揭榜方要求：{{Zblist.Requirements}}</div>
      </div>
      <div class="tonging" v-else v-html="Zblist.ResultsInformation"></div>
    </div>
    <Docking v-if="isf" :DialogVisible.sync="isf" :id="zbdata" :type="ty"></Docking>
  </div>
</template>
<script>
import Docking from '@/components/Docking.vue'
import { getAction, postAction } from '@/api/api'
import qs from 'qs'
import { ZhangBangList, library, NewsList, UserLeave } from '@/api/url'
export default {
  data() {
    return {
      zbdata: 0,
      Zblist: {},
      dialogVisible: false,
      textarea: '', //文字
      isf: false,
      DialogVisible: false,
      ty: 2,
    }
  },
  components: {
    Docking,
  },
  created() {
    this.zbdata = this.$route.query.list
  },
  mounted() {
    this.$bus.$on('LoginSuccess', (e) => {
      //// console.log(e);
      if (e) {
        this.ZbDatad()
      }
    })
    this.ZbDatad()
  },
  methods: {
    ZbDatad() {
      let data = {
        action: 'Get_ZhangBangById',
        id: this.zbdata,
      }
      getAction(ZhangBangList, data).then((res) => {
        //// console.log(res);
        this.Zblist = res
      })
    },
    Zbguashui(id) {
      let data = window.localStorage.getItem('RealName')
      if (data == '') {
        this.$confirm('当前未登录,是否跳转到登录页?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', true)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        //IsTechnical 0
        let type = 0
        if (this.Zblist.IsTechnical == 0) {
          type = 4
        } else {
          type = 5
        }
        let b = window.localStorage.getItem('RealID')
        let data = {
          action: 'Collection_Items',
          ProjectID: id,
          UserID: b,
          type: type,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          if (res.status == 'n') {
            this.$message.success('取消收藏')
          } else {
            this.$message.success('已经收藏')
          }
          this.ZbDatad()
        })
      }
    },
    docking() {
      let data = window.localStorage.getItem('RealName')
      if (data == '') {
        this.$confirm('当前未登录,是否跳转到登录页?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', true)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.isf = !this.isf
      }
    },
    //登录
    LoginSuccess() {
      let data = {
        action: 'Get_UserInfo',
      }
      postAction(library, qs.stringify(data)).then((res) => {
        this.RealName = res.RealName
        window.localStorage.setItem('RealName', res.RealName)
      })
      this.$router.go(0)
    },
    //留言
    dialogAdd() {
      this.dialogVisible = false
      let data = {
        action: 'Filter_Words',
        Words: this.textarea,
      }
      postAction(NewsList, qs.stringify(data)).then((res) => {
        if (res == 0) {
          let b = window.localStorage.getItem('RealID')
          let datal = {
            action: 'Add',
            userid: b,
            projectid: this.zbdata,
            type: 2,
            content: this.textarea,
          }
          postAction(UserLeave, qs.stringify(datal)).then((res) => {
            if (res.status == 0) {
              this.$message.success('留言成功')
            } else {
              this.$message.success('留言失败')
            }
          })
        } else {
          this.$message.success('您的留言有违规字样，请重新编辑')
        }
      })
    },
  },
}
</script>
<style scoped>
body {
  margin: 0rem;
  font-family: Microsoft YaHei;
  left: 0rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  box-sizing: border-box;
}
.w {
  width: 80rem;
  margin: 3rem auto 5rem;
}
#header {
  height: 7.4375rem;
  border-bottom: 0.0625rem solid #ffffffa9;
  background-color: #222222;
  width: 100%;
}
.datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.datails_nav .layui-breadcrumb a {
  color: #999 !important;
}
.lang {
  margin: 0 10px;
  color: #999;
}
.toptitle {
  overflow: hidden;
  text-align: left;
}
.titletext {
  font-size: 2rem;
  font-weight: 800;
  margin-top: 2rem;
}
.titlespan {
  width: 75%;
}
.titlespan > p {
  margin-top: 1.5rem;
  color: #999;
  font-size: 1rem;
  max-width: 56.25rem;
}
.titlespan > div > p {
  display: inline-block;
  color: #999;
  font-size: 1rem;
}
.hr {
  border-bottom: 0.1rem solid #ccc;
  padding-bottom: 2rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.btnShou {
  height: 3rem;
  line-height: 3rem;
  border: 1px solid transparent;
  padding: 0 2rem;
  background-color: #fff;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 1.2rem;
  border-radius: 2px;
  cursor: pointer;
}
.bnt-one {
  border-color: #ffb800 !important;
  color: #ffb800 !important;
}
.btnShou img {
  vertical-align: middle;
  margin-right: 0.3rem;
}
.jiedui {
  background-color: #1e9fff;
  height: 3rem;
  line-height: 3rem;
  border: 1px solid transparent;
  padding: 0 1rem;
  margin-left: 1rem;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
}
.jiedui img {
  vertical-align: middle;
  width: 1.5625rem;
  height: 1.4375rem;
}
.datg {
  margin-top: 1.5rem;
  text-align: left !important;
}
.datg span {
  font-size: 1rem;
}
.tonging {
  font-size: 1.5rem;
  line-height: 3rem;
}
.quing {
  margin-top: 1rem;
  line-height: 2rem;
}
::v-deep .el-dialog__title {
  font-weight: 600;
  font-size: 1.75rem;
}
::v-deep .el-textarea__inner {
  height: 12.5rem;
}
.person {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
</style>
